import React, {Component} from "react"
import AddressBook from "components/Address/AddressBook"

export default class AddressBookPage extends Component {

  render() {
    return (
      <div >
        <AddressBook backlink="/checkout/delivery"/>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/pages/checkout/AddressBookPage.js